<template>
  <public-page :hasBg="true">
    <div class="block">
      <div class="titleName">
        全资子公司
        <div class="after">
          <div class="red"></div>
          <div class="blue"></div>
        </div>
      </div>
      <div class="list">
        <nuxt-link :to="item.isContent === 0 ? `/gywm/lqqx/${item.id}?from=/gywm/lqqx` : 'javaScript:;'" class="li" v-for="item in its['1']" :title="item.companyName">
          <img src="../../../assets/images/pages/about/son.png" alt="son">
          {{item.companyName}}
        </nuxt-link>
      </div>
    </div>
    <div class="block">
      <div class="titleName">分公司
        <div class="after">
          <div class="red"></div>
          <div class="blue"></div>
        </div>
      </div>
      <div class="list">
        <nuxt-link :to="item.isContent === 0 ? `/gywm/lqqx/${item.id}?from=/gywm/lqqx` : 'javaScript:;'" class="li" v-for="item in its['2']" :title="item.companyName">
          <img src="../../../assets/images/pages/about/son.png" alt="son">
          {{item.companyName}}
        </nuxt-link>
      </div>
    </div>
    <div class="block">
      <div class="titleName">项目运营公司
        <div class="after">
          <div class="red"></div>
          <div class="blue"></div>
        </div>
      </div>
      <div class="list">
        <nuxt-link :to="item.isContent === 0 ? `/gywm/lqqx/${item.id}?from=/gywm/lqqx` : 'javaScript:;'" class="li" v-for="item in its['3']" :title="item.companyName">
          <img src="../../../assets/images/pages/about/son.png" alt="son">
          {{item.companyName}}
        </nuxt-link>
      </div>
    </div>
    <div class="block">
      <div class="titleName">股权合作单位
        <div class="after">
          <div class="red"></div>
          <div class="blue"></div>
        </div>
      </div>
      <div class="list">
        <nuxt-link :to="item.isContent === 0 ? `/gywm/lqqx/${item.id}?from=/gywm/lqqx` : 'javaScript:;'" class="li" v-for="item in its['4']" :title="item.companyName">
          <img src="../../../assets/images/pages/about/son.png" alt="son">
          {{item.companyName}}
        </nuxt-link>
      </div>
    </div>
  </public-page>
</template>

<script setup>
import PublicPage from "../components/publicPage";
import {ref} from "vue";
import {getIts} from "../../../apis/gywm";
const fileHost = import.meta.env.VITE_FILE_HOST

const its = ref([]);
const itsRes = await useAsyncData("getIts", () => getIts());

if (itsRes.data.value.code !== 200) {
  its.value = []
  throw createError({statusCode: itsRes.data.value.code, statusMessage: encodeURIComponent("获取路桥旗下数据失败")})
} else {
  let _itsData = itsRes.data.value.data;
  let _its = {
    "1": [],
    "2": [],
    "3": [],
    "4": [],
  };
  _itsData.forEach(item => {
    switch (item.companyType){
      case "1":
        _its['1'].push({...item, logo: fileHost + item.companyLogo})
        break
      case "2":
        _its['2'].push({...item, logo: fileHost + item.companyLogo})
        break
      case "3":
        _its['3'].push({...item, logo: fileHost + item.companyLogo})
        break
      case "4":
        _its['4'].push({...item, logo: fileHost + item.companyLogo})
        break
    }
  })
  its.value = _its
}

// 设置TDK
useHead({
  title: '路桥旗下|关于我们 - 郑州路桥建设投资集团有限公司',
})
</script>

<style scoped lang="scss">
.block {
  margin-top: 20px;
  text-align: center;
  .titleName {
    text-align: center;
    font-size: 28px;
    line-height: 50px;
    color: var(--block-title-color);
    display: inline-block;
    position: relative;
    margin-bottom: 50px;
    .after {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 4px;
      //content: "";
      //display: block;
      width: 100%;
      height: 4px;
      //padding: 0 10px;
      //background: var(--main-blue-color);
      display: flex;
      align-items: center;
      > div {
        height: 100%;
      }
      .red {
        background: #E50012;
        width: 40%;
      }
      .blue {
        background: #003586;
        width: 60%;
      }
    }
  }
  .list {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: 100px;
    .li {
      margin-right: 10px;
      font-size: 20px;
      //line-height: 50px;
      line-height: 1.5;
      color: #163F5D;
      width: 426px;
      box-sizing: border-box;
      //border: 1px solid #D8D8D8;
      text-align: left;
      margin-bottom: 30px;
      > img {
        width: 11px;
        height: 11px;
        margin-right: 1px;
      }
      &:hover {
        //border-color: #E50012;
        color: var(--main-blue-color);
        text-decoration-color: var(--main-blue-color);
        text-underline-offset: 4px;
        //background: #fff;
      }
    }
    .li:nth-child(3n){
      margin-right: 0;
    }
  }
  
}
</style>